import * as React from "react";

import { Button } from "@fluentui/react-components";
import { devices } from "library/constants";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { useAppTheme } from "hooks/useAppTheme";
import { useHasGivenConsent } from "hooks/useHasGivenConsent";

type AppNavigationProps = {
  pageRoute?: string;
  label: string;
  disabled?: boolean;
  Icon: ({ isActive, disabled, ...rest }) => JSX.Element;

  btnAction?: () => void;
};

export const MobileNavItem: React.FC<AppNavigationProps> = ({
  pageRoute,
  label,
  disabled,
  Icon,
  btnAction,
}) => {
  const theme = useAppTheme();
  const navigate = useNavigate();

  const hasGivenConsent = useHasGivenConsent();

  const { pathname } = useLocation();

  const isActivePage = pathname === pageRoute;

  const handleNavItemClick = () => {
    if (btnAction) {
      btnAction();
      return;
    }
    navigate(pageRoute || "");
  };

  return (
    <>
      <StyledButton
        disabled={disabled || !hasGivenConsent}
        size="large"
        appearance="transparent"
        $itemColor={theme.palette.purpleDark}
        $active={isActivePage}
        onClick={handleNavItemClick}
        icon={
          <Icon
            disabled={disabled || !hasGivenConsent}
            isActive={isActivePage}
            style={{
              borderRadius: "50%",
              padding: "1px",
            }}
          />
        }
      >
        {label}
      </StyledButton>
    </>
  );
};

const StyledButton = styled(Button)<{ $active?: boolean; $itemColor?: string }>`
  display: flex;
  align-items: center;
  gap: 0;
  flex-direction: column;
  font-weight: ${({ $active }) => ($active ? 800 : 600)} !important;
  font-size: 10px !important;
  min-width: 50px !important;
  padding: 2px !important;
  .fui-Button__icon {
    width: 26px !important;
    height: 24px !important;
    margin-right: 0;
  }

  &:not(:disabled) {
    color: ${({ theme, $itemColor, $active }) => ($active ? $itemColor : theme.palette.black)};
  }

  @media only screen and ${devices.xs2} {
    font-size: 12px !important;
  }

  @media only screen and ${devices.md} {
    flex-direction: row;
    gap: 5px;
    font-size: 14px !important;
  }
`;
